// Notification Data Model
export const notificationModel = {
  // Notification Collection Structure
  collection: 'notifications',
  
  // Default Notification Document Structure
  defaultDocument: {
    id: '', // Auto-generated by Firestore
    userId: '', // User who receives the notification
    type: '', // order_new, order_status, bid_new, review_new, chat_new
    title: '', // Notification title
    message: '', // Notification message
    data: {}, // Additional data (orderId, productId, etc.)
    
    // Status
    read: false, // Whether notification has been read
    readAt: null, // When notification was read
    
    // Metadata
    createdAt: '', // ISO string
    updatedAt: '' // ISO string
  },
  
  // Notification Types
  types: {
    ORDER_NEW: 'order_new', // ออเดอร์ใหม่
    ORDER_STATUS: 'order_status', // สถานะออเดอร์เปลี่ยน
    BID_NEW: 'bid_new', // มีการเสนอราคาใหม่
    REVIEW_NEW: 'review_new', // มีรีวิวใหม่
    CHAT_NEW: 'chat_new', // มีข้อความใหม่
    AUCTION_ENDING: 'auction_ending', // ประมูลใกล้หมดเวลา
    AUCTION_WON: 'auction_won', // ชนะประมูล
    AUCTION_WINNER_CONFIRMED: 'auction_winner_confirmed', // ผู้ขายยืนยันผู้ชนะ
    AUCTION_CANCELLED: 'auction_cancelled', // ประมูลถูกยกเลิก
    ORDER_CREATED: 'order_created', // ออเดอร์ถูกสร้าง
    BUYER_REQUEST_OFFER: 'buyer_request_offer', // มีคนเสนอราคาในประกาศหาสินค้า
    PAYMENT_PROOF_UPLOADED: 'payment_proof_uploaded', // ผู้ซื้ออัพโหลดหลักฐานการโอนแล้ว
    ADMIN_MIDDLEMAN_ORDER: 'admin_middleman_order', // ออเดอร์ที่ใช้แอดมินเป็นตัวกลาง
    VIDEO_CALL_REQUEST: 'video_call_request', // มี Video Call Request ใหม่
    VIDEO_CALL_APPROVED: 'video_call_approved', // Video Call ถูกอนุมัติ
    VIDEO_CALL_REJECTED: 'video_call_rejected', // Video Call ถูกปฏิเสธ
    VIDEO_CALL_REMINDER: 'video_call_reminder', // แจ้งเตือนก่อน Video Call
    VIDEO_CALL_INCOMING: 'video_call_incoming', // มี Video Call เข้ามา (incoming call)
    PACKAGE_EXPIRING: 'package_expiring', // แพ็กเกจใกล้หมดอายุ
    CAMPAIGN_APPROVED: 'campaign_approved', // Campaign ถูกอนุมัติ
    CAMPAIGN_REJECTED: 'campaign_rejected', // Campaign ถูกปฏิเสธ
    CAMPAIGN_EXPIRING: 'campaign_expiring', // Campaign ใกล้หมดอายุ
    CAMPAIGN_EXPIRED: 'campaign_expired', // Campaign หมดอายุ
    TEAM_REQUEST: 'team_request', // มีคำขอเข้าร่วมทีม
    TEAM_INVITATION: 'team_invitation', // ได้รับคำเชิญเข้าทีม
    TEAM_APPROVED: 'team_approved', // คำขอเข้าร่วมทีมถูกอนุมัติ
    TEAM_REJECTED: 'team_rejected', // คำขอเข้าร่วมทีมถูกปฏิเสธ
    TEAM_MEMBER_REMOVED: 'team_member_removed', // ถูกลบออกจากทีม
    TEAM_ROLE_CHANGED: 'team_role_changed', // สิทธิ์ถูกเปลี่ยน
    SHIFT_ASSIGNED: 'shift_assigned', // ได้รับมอบหมายเวร
    SHIFT_SWAP_REQUEST: 'shift_swap_request', // มีคำขอแลกเวร
    SHIFT_SWAP_APPROVED: 'shift_swap_approved', // คำขอแลกเวรถูกอนุมัติ
    SHIFT_SWAP_REJECTED: 'shift_swap_rejected', // คำขอแลกเวรถูกปฏิเสธ
    SHIFT_SWAP_LEADER_APPROVAL: 'shift_swap_leader_approval', // มีคำขอแลกเวรรอหัวหน้าอนุมัติ
    SHIFT_REMINDER: 'shift_reminder', // แจ้งเตือนเวรใกล้ถึงเวลา
    SHIFT_PLAN_CREATED: 'shift_plan_created', // มีแผนเวรใหม่
    SHIFT_PLAN_VERSION_CREATED: 'shift_plan_version_created', // มีแผนเวร version ใหม่
    INSPECTION_SUBMITTED: 'inspection_submitted', // มีการส่งผลการตรวจสอบใหม่
    INSPECTION_UPDATED: 'inspection_updated', // มีการแก้ไขผลการตรวจสอบ
    INSPECTION_APPROVED: 'inspection_approved', // ผลการตรวจสอบได้รับการอนุมัติ
    INSPECTION_REJECTED: 'inspection_rejected', // ผลการตรวจสอบถูกปฏิเสธ
    EQUIPMENT_BORROW_REQUESTED: 'equipment_borrow_requested', // มีคำขอยืมอุปกรณ์ใหม่
    EQUIPMENT_BORROW_APPROVED: 'equipment_borrow_approved', // คำขอยืมอุปกรณ์ได้รับการอนุมัติ
    EQUIPMENT_BORROW_REJECTED: 'equipment_borrow_rejected', // คำขอยืมอุปกรณ์ถูกปฏิเสธ
    EQUIPMENT_RETURN_REQUESTED: 'equipment_return_requested', // มีคำขอคืนอุปกรณ์
    EQUIPMENT_RETURN_APPROVED: 'equipment_return_approved', // คำขอคืนอุปกรณ์ได้รับการอนุมัติ
    EQUIPMENT_RETURN_REJECTED: 'equipment_return_rejected', // คำขอคืนอุปกรณ์ถูกปฏิเสธ
    EQUIPMENT_REPAIR_REQUESTED: 'equipment_repair_requested', // มีคำขอส่งซ่อมอุปกรณ์
    EQUIPMENT_REPAIR_APPROVED: 'equipment_repair_approved', // คำขอส่งซ่อมได้รับการอนุมัติ
    EQUIPMENT_REPAIR_REJECTED: 'equipment_repair_rejected', // คำขอส่งซ่อมถูกปฏิเสธ
    EQUIPMENT_REPAIR_COMPLETION_REQUESTED: 'equipment_repair_completion_requested', // มีคำขอซ่อมเสร็จใหม่
    EQUIPMENT_REPAIR_COMPLETED: 'equipment_repair_completed', // อุปกรณ์ซ่อมเสร็จแล้ว
    EQUIPMENT_REPAIR_RECEIVE_REQUESTED: 'equipment_repair_receive_requested', // มีคำขอรับกลับอุปกรณ์จากการซ่อม
    EQUIPMENT_REPAIR_RECEIVE_APPROVED: 'equipment_repair_receive_approved', // คำขอรับกลับได้รับการอนุมัติ
    EQUIPMENT_REPAIR_RECEIVE_REJECTED: 'equipment_repair_receive_rejected', // คำขอรับกลับถูกปฏิเสธ
    EQUIPMENT_CREATED: 'equipment_created', // มีอุปกรณ์ใหม่รออนุมัติ
    EQUIPMENT_APPROVED: 'equipment_approved', // อุปกรณ์ได้รับการอนุมัติ
    EQUIPMENT_REJECTED: 'equipment_rejected', // อุปกรณ์ถูกปฏิเสธ
    EQUIPMENT_UPDATED: 'equipment_updated', // อุปกรณ์ถูกแก้ไข (รออนุมัติอีกครั้ง)
    GIFT_RECEIVED: 'gift_received' // ได้รับของขวัญ
  },
  
  // Notification Icons
  icons: {
    order_new: '🛒',
    order_status: '📦',
    bid_new: '💰',
    review_new: '⭐',
    chat_new: '💬',
    auction_ending: '⏰',
    auction_won: '🏆',
    auction_winner_confirmed: '✅',
    auction_cancelled: '❌',
    order_created: '📦',
    buyer_request_offer: '📢',
    payment_proof_uploaded: '💳',
    admin_middleman_order: '🛡️',
    video_call_request: '📹',
    video_call_approved: '✅',
    video_call_rejected: '❌',
    video_call_reminder: '⏰',
    video_call_incoming: '📞',
    package_expiring: '⏰',
    campaign_approved: '✅',
    campaign_rejected: '❌',
    campaign_expiring: '⏰',
    campaign_expired: '🔴',
    team_request: '👥',
    team_invitation: '📨',
    team_approved: '✅',
    team_rejected: '❌',
    team_member_removed: '🚫',
    team_role_changed: '🔐',
    shift_assigned: '📅',
    shift_swap_request: '🔄',
    shift_swap_approved: '✅',
    shift_swap_rejected: '❌',
    shift_swap_leader_approval: '👔',
    shift_reminder: '⏰',
    shift_plan_created: '📅',
    shift_plan_version_created: '📅',
    inspection_submitted: '📋',
    inspection_updated: '✏️',
    inspection_approved: '✅',
    inspection_rejected: '❌',
    equipment_borrow_requested: '📦',
    equipment_borrow_approved: '✅',
    equipment_borrow_rejected: '❌',
    equipment_return_requested: '📥',
    equipment_return_approved: '✅',
    equipment_return_rejected: '❌',
    equipment_repair_requested: '🔧',
    equipment_repair_approved: '✅',
    equipment_repair_rejected: '❌',
    equipment_repair_completion_requested: '📋',
    equipment_repair_completed: '✅',
    equipment_repair_receive_requested: '📥',
    equipment_repair_receive_approved: '✅',
    equipment_repair_receive_rejected: '❌',
    equipment_created: '📦',
    equipment_approved: '✅',
    equipment_rejected: '❌',
    equipment_updated: '✏️',
    gift_received: '🎁'
  },
  
  // Create notification helper
  createNotification: (userId, type, title, message, data = {}) => {
    return {
      ...notificationModel.defaultDocument,
      userId,
      type,
      title,
      message,
      data,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    };
  }
};

export default notificationModel;


